import React from "react";
import { HeaderSearchListSection } from "./styles";
import SearchIntialRender from "./SearchIntialRender";
import { useCheckTradePage } from "@utils/ExpensiveFunction";
import { useWindowDimensions } from "@app/hooks";
import HeaderSearchLists from "./HeaderSearchLists";

interface Iprops {
  text?: string;
}
const HeaderSearchList = ({ text }: Iprops) => {
  const { width } = useWindowDimensions();
  const checkSize = width < 900;
  const otherPage = checkSize ? 80 : 60;

  // 위치 계산 - 검색창 기준 중앙 정렬 (CSS에서 left: 50%, transform: translateX(-50%)로 처리)
  const positionStyle: any = {
    top: useCheckTradePage() ? 40 : otherPage,
  };

  // 모바일에서는 전체 너비
  if (width < 600) {
    positionStyle.left = 0;
    positionStyle.right = 0;
    positionStyle.transform = 'none';
  }

  return (
    <HeaderSearchListSection
      style={positionStyle}
    >
      {text?.length ? (
        <HeaderSearchLists search={text} />
      ) : (
        <SearchIntialRender />
      )}
    </HeaderSearchListSection>
  );
};

export default React.memo(HeaderSearchList);
